import { getStore } from '@/store';
import { setRecentlySearch } from '../../md-search-bar/_util';
import * as TYPES from '@/components/search-result/_store/types';
import { paramsSerializer } from '@/common/utils/url-params';
import util from '@/common/util';
import {
    isMigrationAdvertLink,
    handleMdSearchCondition,
    getSearchRequestUrl,
    mergeMlsOrg2HouseList,
    params2linkHash
} from '@/common/search-request';
export const ADD_KEYWORD_MUTATION = 'ADD_KEYWORD_MUTATION';
export const MODE_SET_MUTATION = 'MODE_SET_MUTATION';
export const MODE_UPDATE_MUTATION = 'MODE_UPDATE_MUTATION';
export const LAYOUTOPTIONS_UPDATE_MUTATION = 'LAYOUTOPTIONS_UPDATE_MUTATION';
export const LISTING_SOURCE_MUTATION = 'LISTING_SOURCE_MUTATION';
export const OTHER_URL_QUERY_MUTATION = 'OTHER_URL_QUERY_MUTATION';
export const NAVIGATOR_DETAIL = 'NAVIGATOR_DETAIL';
export const SET_GO_DETAIL = 'SET_GO_DETAIL';
export const SET_LISTING_SOURCE_READY = 'SET_LISTING_SOURCE_READY';
export const RESULT_UPDATE_MUTATION = 'RESULT_UPDATE_MUTATION';
export const SET_SEARCH_DATA_READY = 'SET_SEARCH_DATA_READY';
export const SET_LISTING_IDS = 'SET_LISTING_IDS';
export const SET_LISTINGIDS_MUTATION = 'SET_LISTINGIDS_MUTATION';
export const SET_APPLY_MAP = 'SET_APPLY_MAP';
const IGNORE_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_id',
    'x_ads_id',
    'x_ads_source',
    'quickSearchCount',
    'quickSearchKey'
];
const queryKeyOnResult = [
    /* search result  The parameters that need to be used in   start */
    'listingSortOptions',
    'mode',
    'gridOrListType',
    // 'mapType',
    'layoutType',
    'sort',
    'listingSort',
    'featureListingName',
    'listingSource',
    /* search result  The parameters that need to be used in   end */
    'nopreset', //  obsolete parameter ， If you encounter stock url delete if it exists
    'breakCrumbs', //  Get breadcrumb configuration
    '_t'
];
function initState() {
    return {
        goDetail: false,
        // searchModuleType: '',
        keywords: [],
        mode: '',
        // mixed表示左边地图, 右边grid/list
        // map表示只有大地图
        // normal表示只有grid/list
        // layoutOptions: ['mixed', 'map', 'normal'],
        // layout: 'mixed',
        layoutOptions: ['normal'],
        layout: 'normal',
        listingSource: '',
        otherUrlQuery: {},
        listingSourceReady: false,
        fetchedSearchData: false,
        mapCondition: {
            rect: null,
            mapPath: null,
            mapSearch: false,
            zoom: 14,
            threshold: 10,
            mapRadius: null
        },
        result: {
            counts: 0,
            searchType: 'All',
            listings: [],
            totalPage: 0
        }
        // blockId: ''
    };
}

// Gets the historical quickSearch cache map structure.
const updateQuickSearchCount = function(key, count) {
    this.axiosIns
        .get('/api-site/place-data?fetcher=data&source=quicksearchCount', { noCache: true })
        .then(res => {
            let quickSearchCount = res.data || {};
            if (typeof quickSearchCount === 'string') {
                quickSearchCount = JSON.parse(quickSearchCount);
            }
            quickSearchCount[key] = count;
            // Update the map cache data to cache the current query interface.
            this.axiosIns.post('/api-site/place-data', {
                source: 'quicksearchCount',
                data: JSON.stringify(quickSearchCount)
            });
        });
};

const getters = {
    // mode: state => {
    //     if (!state.layout) {
    //         return '';
    //     }
    //     return (
    //         state.layout +
    //         (state.layout === 'map' && state.mapType ? '+' + state.mapType : '')
    //     );
    // },
    insightMode(state) {
        if (/insight/.test(state.mode)) {
            return state.mode;
        }
        return '';
    },
    layoutState(state) {
        return (state.layout === 'map' || state.layout === 'mixed') ? 'map' : state.gridOrListType
    },
    mapType(state) {
        return state.layout === 'map' ? '' : state.gridOrListType
    },
    isMixed(state) {
        return !this.isBigMap && !this.isGridOrList;
    },
    isBigMap(state) {
        // return state.searchModuleType === searchModuleType.bigMap;
        return state.layoutOptions.length === 1 && state.layoutOptions[0] === 'map';
    },
    isGridOrList(state) {
        // return state.searchModuleType === searchModuleType.gridList;
        return state.layoutOptions.length === 1 && state.layoutOptions[0] === 'normal';
    },
    isSold(state) {
        let reg = /^\d\+/;
        const listingSource = state.listingSource || '';
        const { soldListingFlag } = getStore.call(this, 'page');
        return (
            reg.test(listingSource) &&
            listingSource[0] === soldListingFlag
        );
    },
    listingType(state) {
        if (
            this.isSold ||
            (state.listingSource || '').toLowerCase() === 'sold listings'
        ) {
            return 'sold-listing';
        } else {
            return util.getListingTypeFromListingSource(state.listingSource)
        }
    },
    locationQuantity(state) {
        if (state.keywords.length > 0) {
            return {
                count: state.keywords.length,
                type: 'addr'
            };
        }
        if (state.mapCondition.mapSearch) {
            return {
                count: 1,
                type: 'mapArea'
            };
        }
        if (state.mapCondition.mapPath) {
            return {
                count: 1,
                type: 'mapPath'
            };
        }
        if (state.mapCondition.mapRadius) {
            return {
                count: 1,
                type: 'mapRadius'
            };
        }
        return {
            count: 0
        };
    },
    locationType(state) {
        const locationQuantity = this.locationQuantity;
        const keywords = state.keywords;
        const hasNoneType = keywords.find(item => item.keywordType === 'none');
        if (
            locationQuantity.type === 'addr' &&
            locationQuantity.count === 1 &&
            !hasNoneType
        ) {
            return 'single';
        }
        if (locationQuantity.count === 0) {
            return 'none';
        }
        return 'multi';
    },
    noMapSearch(state) {
        const { mapCondition, keywords } = state;
        const { mapPath, mapSearch } = mapCondition;
        return !mapPath && !mapSearch && keywords && keywords.length === 0;
    },
    otherSearchParams(state) {
        let { page: globalData } = getStore.call(this, 'page');
        let params = Object.assign({}, state.otherUrlQuery);
        if (params.listingSource) {
            delete params.listingSource;
        }
        // CHIME-19042
        if (!isMigrationAdvertLink.call(this, globalData)) {
            if (params.key) {
                delete params.key;
            }
            if (params.keywordType) {
                delete params.keywordType;
            }
            for (let kee in state.mapCondition) {
                if (params[kee]) {
                    delete params[kee];
                }
            }
        }
        IGNORE_PARAMS.forEach(kee => {
            if (params[kee]) {
                delete params[kee];
            }
        });
        return params;
    }
};

const actions = {
    [SET_GO_DETAIL](payload) {
        this.goDetail = payload;
    },
    [OTHER_URL_QUERY_MUTATION](payload = {}) {
        this.$patch(state => {
            queryKeyOnResult.forEach(key => {
                delete payload[key];
            });
            state.otherUrlQuery = Object.assign({}, payload);
        });
    },
    [TYPES.MAP_CHANGE_MUTATION](payload) {
        this.$patch(state => {
            let mapCondition = Object.assign({}, state.mapCondition, payload);
            //mapSearch  and  mapPath  cannot coexist
            if (payload.mapSearch) {
                mapCondition.mapPath = null;
                mapCondition.mapRadius = null;
            }
            if (payload.mapPath) {
                mapCondition.mapSearch = false;
                mapCondition.mapRadius = null;
            }
            if (payload.mapRadius) {
                mapCondition.mapSearch = false;
                mapCondition.mapPath = null;
            }
            //keywords  and  mapPath/mapSearch  mutually exclusive
            if (
                (payload.mapSearch || payload.mapPath || payload.mapRadius) &&
                state.keywords.length > 0
            ) {
                state.keywords = [];
            }
            state.mapCondition = mapCondition;
        });
    },
    [ADD_KEYWORD_MUTATION](payload) {
        this.$patch(state => {
            let keywords = state.keywords;
            if (!payload.keyword) {
                return;
            }
            // keywordType === 'none' means not suggestion
            //  only one   No  suggestion search term for
            if (payload.keywordType === 'none') {
                for (let i = 0; i < keywords.length; i++) {
                    if (keywords[i].keywordType === 'none') {
                        keywords.splice(i, 1);
                        break;
                    }
                }
            } else {
                if (
                    keywords.some(
                        keyword =>
                            keyword.keywordType === payload.keywordType &&
                            keyword.keyword === payload.keyword
                    )
                ) {
                    return;
                }
            }
            let recentlySearch = state.recentlySearch;
            let index = -1;
            //  turn up recentlySearch the first one with payload the same index , and remove
            recentlySearch.some((search, idx) => {
                if (
                    search.keywordType === payload.keywordType &&
                    search.keyword === payload.keyword
                ) {
                    index = idx;
                    return true;
                }
                return false;
            });
            if (index !== -1) {
                recentlySearch.splice(index, 1);
            }
            //  most 3 indivual recentlySearch
            if (recentlySearch.length >= 3) {
                recentlySearch = recentlySearch.slice(0, 2);
            }
            //  Add to
            recentlySearch.unshift(payload);
            //  Will recently search set up cookie
            setRecentlySearch(recentlySearch);
            state.recentlySearch = recentlySearch;

            keywords.push(payload);
            state.keywords = keywords;
            //keywords  and  mapPath/mapSearch  mutually exclusive
            state.mapCondition = Object.assign({}, state.mapCondition, {
                mapPath: null,
                mapSearch: false,
                mapRadius: null
            });
        });
    },
    [MODE_SET_MUTATION]() {
        this.$patch(state => {
            if (state.layout === 'map') {
                state.mode = 'map'
            } else if (state.layout === 'normal') {
                state.mode = state.gridOrListType;
            } else if (state.layout === 'mixed') {
                state.mode = `map+${state.gridOrListType}`
            }
        });
    },
    [MODE_UPDATE_MUTATION](payload) {
        this.$patch(state => {
            let layout = 'normal', gridOrListType = 'grid';
            state.mode = payload.mode;
            if (/map[+ ]grid/i.test(payload.mode)) {
                if (payload.isMobile) {
                    layout = 'normal';
                } else if (state.layoutOptions.indexOf('mixed') !== -1) {
                    layout = 'mixed';
                } else if (state.layoutOptions.indexOf('normal') !== -1) {
                    layout = 'normal';
                }
                gridOrListType = 'grid';
            } else if (/map[+ ]list/i.test(payload.mode)) {
                if (payload.isMobile) {
                    layout = 'normal';
                } else if (state.layoutOptions.indexOf('mixed') !== -1) {
                    layout = 'mixed';
                } else if (state.layoutOptions.indexOf('normal') !== -1) {
                    layout = 'normal';
                }
                gridOrListType = payload.isMobile ? 'grid' : 'list';
            } else if (payload.mode === 'grid' || payload.mode === 'list') {
                if (state.layoutOptions.indexOf('normal') !== -1) {
                    layout = 'normal';
                    gridOrListType = payload.isMobile ? 'grid' : payload.mode;
                }
            } else if (/map/i.test(payload.mode)) {
                // 不是normal就行
                if (state.layoutOptions.indexOf('map') !== -1) {
                    layout = 'map';
                }
            }
            state.layout = layout;
            state.gridOrListType = gridOrListType;
            this[MODE_SET_MUTATION]();
        });
    },
    [LAYOUTOPTIONS_UPDATE_MUTATION](layoutOptions) {
        this.layoutOptions = layoutOptions;
    },
    [TYPES.LAYOUT_UPDATE_MUTATION](payload) {
        let layout = payload.layout;
        this.layout = layout;
        this[MODE_SET_MUTATION]();
    },
    [TYPES.REMOVE_KEYWORD_MUTATION](payload) {
        this.$patch(state => {
            let keywords = state.keywords;
            if (!payload) {
                state.keywords = [];
                return;
            }
            for (let i = 0; i < keywords.length; i++) {
                if (
                    keywords[i].keywordType === payload.keywordType &&
                    keywords[i].keyword === payload.keyword
                ) {
                    keywords.splice(i, 1);
                    break;
                }
            }
            state.keywords = keywords;
        });
    },
    [LISTING_SOURCE_MUTATION](payload) {
        this.listingSource = payload;
    },
    [SET_LISTING_SOURCE_READY](payload) {
        this.listingSourceReady = payload;
    },
    [SET_SEARCH_DATA_READY](payload) {
        this.fetchedSearchData = payload;
    },
    [RESULT_UPDATE_MUTATION](payload) {
        this.result = Object.assign({}, this.result, payload);
    },
    [TYPES.QUICK_SEARCH_STATE_MUTATION](payload) {
        this.quickSearchState = payload;
    },
    [SET_LISTINGIDS_MUTATION](payload) {
        this.listingIds = payload;
    },
    async [TYPES.SEARCH_DATA_ACTION](payload = {}) {
        let { page: globalData, siteId, isSearchCenter } = getStore.call(this, 'page');
        let listingSource = (this.listingSource || '')
            .replace(/^\d\+/, '')
            .replace(/\+/g, ' ');
        let { otherSearchParams } = this
        let params = Object.assign(
            {
                ...otherSearchParams
            },
            {
                featureListingName:
                    [
                        'all listings',
                        'sold listings',
                        'single property promotion'
                    ].indexOf(listingSource.toLowerCase()) !== -1 ||
                    !listingSource
                        ? undefined
                        : listingSource,
                listingSort: this.sort,
                layoutType: this.layoutState,
                mapType: this.mapType,
                listingType: this.resultListingType,
                page: this.page,
                pageSize: this.pageSize,
                isSearching: true,
                siteId: siteId,
                ...this.searchParamsWithMap,
                ...this.mapCondition
            }
        );
        // CHIME-19042
        if (isMigrationAdvertLink.call(this, globalData)) {
            params = { ...params, ...otherSearchParams };
        }

        //  Need not ids use listingIds
        delete params['ids'];

        //  Request parameters plus listingIds,crmAlertId will be cleared when it exists listingIds
        // state.listingIds  By default it will save listingIds or ids the value of
        // crmAlertId  delete if present ids and listingIds
        if (this.listingIds && !('crmAlertId' in params)) {
            Object.assign(params, { listingIds: this.listingIds });
        }

        //  Search criteria cannot have redundant parameters
        delete params[siteId];
        if (
            !util.isSSRServer &&
            (window.sitePageAutoInit === false ||
            window.location.pathname === '/listing-for-cms')
        ) {
            params.timeStamp = Date.now();
        }
        let ps = [];
        // let page = rootState.page?.page || {};
        const quickSearchCount =
            globalData.URI_REQUEST_PARAMS &&
            globalData.URI_REQUEST_PARAMS['quickSearchCount'];
        const quickSearchKey =
            globalData.URI_REQUEST_PARAMS &&
            globalData.URI_REQUEST_PARAMS['quickSearchKey'];

        if (payload.listOnly) {
            let listParams = JSON.parse(JSON.stringify(params));
            // CHIME-19042
            if (!isMigrationAdvertLink.call(this, globalData)) {
                if (!listParams.mapSearch) {
                    delete listParams.rect;
                } else if (listParams.rect) {
                    const posArr = listParams.rect.split(',');
                    let mapPathArr = [
                        { lat: posArr[0], lng: posArr[1] },
                        { lat: posArr[0], lng: posArr[3] },
                        { lat: posArr[2], lng: posArr[3] },
                        { lat: posArr[2], lng: posArr[1] }
                    ];

                    if (isSearchCenter) {
                        mapPathArr = mapPathArr.map(o => JSON.stringify(o));
                        listParams.condition = listParams.condition
                            ? JSON.parse(listParams.condition)
                            : {};
                        listParams.condition.location ||
                            (listParams.condition.location = {});
                        listParams.condition.location.mapPath = mapPathArr;
                        listParams.condition = JSON.stringify(listParams.condition);
                    } else {
                        const mapPath = JSON.stringify(mapPathArr);
                        listParams.mapPath = mapPath;
                    }

                    delete listParams.rect;
                }
            }

            if (this.isGridOrList) {
                params.layoutType = this.gridOrListType;
                params.mapType = null;
            }
            listParams.mapSearch = false;
            if (!payload.noTimeline) {
                listParams.timeline = true;
            }
            if (this.locationType === 'single') {
                // listParams.mode = `${listParams.layoutType}+${listParams.mapType}`;
                listParams.mode = this.mode;
                delete listParams.layoutType;
                delete listParams.mapType;
            }
            listParams.listingSortOptions = JSON.stringify(
                this.listingSortOptions
            );
            // listParams.nopreset = 1;
            this.loading = true;
            // listParams._t = state.blockId;
            listParams.timezone = this.getCookie('timezone') || util.getTimeZone();
            listParams = await handleMdSearchCondition.call(this, JSON.parse(JSON.stringify(listParams)), globalData);
            ps.push(
                this.axiosIns.get(getSearchRequestUrl.call(this, 'list', globalData), {
                    cancelKey: 'getSearchRequestUrlForList' + this.$id,
                    params: listParams
                }).then(data => {
                    let { listingType } = listParams;
                    if (listingType === 'featured-listing') {
                        listParams.source = 'feature_listing';
                    } else {
                        listParams.source = 'search';
                    }
                    delete listParams.listingType;
                    let list = data.listings || data.house || [];
                    list.forEach(v => {
                        if (v.detailUrl) {
                            v.detailLink = v.detailUrl + '?' + paramsSerializer(listParams);
                        }
                    });
                    return data;
                }).then(data => {
                    // data = mockListFilter(data);
                    data.listings = mergeMlsOrg2HouseList.call(this, data.listings, data.mlsOrgList);
                    if (!data.counts) {
                        data.counts = 0;
                        data.totalPage = 0;
                    }

                    const len = Object.keys(this.searchParamsWithMap).filter(
                        key => !['condition', 'uiConfig', 'zoom'].includes(key)
                    ).length;
                    // parseJSON
                    const conditions = !!Object.keys(util.parseJSON(listParams?.condition ?? '{}', {})).length;
                    const searchBarParamsLen =
                        'listingSource' in this.searchParamsWithMap
                            ? len > 1
                            : !!len;
                    setDynamicRegisterParams(
                        Object.assign({}, listParams, {
                            counts: data?.counts || 0,
                            //  have a choice searchbar parameters   The middle station puts all the parameters in condition  Non-middle stations are placed in the first-level parameters （searchParamsWithMap）
                            hasCondition: conditions || searchBarParamsLen
                        })
                    );
                    this.loading = false;

                    this[RESULT_UPDATE_MUTATION](data);
                    // setTimeout(() => (state.loading = false), 500);
                    if (
                        quickSearchCount &&
                        data.counts != quickSearchCount
                    ) {
                        updateQuickSearchCount.call(this, quickSearchKey, data.counts);
                    }
                    if (!util.isSSRServer && window.siteAppVm) {
                        window.siteAppVm.$EventBus.$emit('siteTrack', {
                            trackType: 'search-result',
                            data: data.listings,
                            params: listParams
                        });
                    }

                    if (
                        !util.isSSRServer &&
                        this.goDetail &&
                        Array.isArray(data.listings) &&
                        data.listings.length === 1 &&
                        window.location.pathname.indexOf('listing-for-cms') < 0
                    ) {
                        this[NAVIGATOR_DETAIL](data.listings);
                        return;
                    }
                })
            );
        }
        if (payload.mapOnly) {
            let mapParams = JSON.parse(JSON.stringify(params));
            // mobile map: Aggregate data
            mapParams.mobile = payload.isMobile;
            mapParams.mapSearch = true;
            delete mapParams.timeline
            if (this.isBigMap) {
                mapParams.layoutType = 'map';
                mapParams.mapType = null;
            }
            this[TYPES.UPDATE_IS_MAP_LOADING](true);
            // mapParams._t = state.blockId;
            // keywordType for “none” hour   Search outside the current map
            // CHIME-19042
            if (
                !isMigrationAdvertLink.call(this, globalData) &&
                'keywordType' in mapParams &&
                mapParams.keywordType === 'none'
            ) {
                delete mapParams.rect;
            }
            mapParams.timezone = this.getCookie('timezone') || util.getTimeZone();
            mapParams = await handleMdSearchCondition.call(this, mapParams, globalData);
            ps.push(
                this.axiosIns.get(getSearchRequestUrl.call(this, 'map', globalData), {
                    cancelKey: 'getSearchRequestUrlForMap' + this.$id,
                    params: mapParams
                }).then(data => {
                    let { listingType } = mapParams;
                    if (listingType === 'featured-listing') {
                        mapParams.source = 'feature_listing';
                    } else {
                        mapParams.source = 'search';
                    }
                    delete mapParams.listingType;
                    let list = data.listings || data.house || [];
                    list.forEach(v => {
                        if (v.detailUrl) {
                            v.detailLink = v.detailUrl + '?' + paramsSerializer(mapParams);
                        }
                    });
                    return data;
                }).then(data => {
                    // data = mockMapFilter(data);
                    delete data.listings;
                    data.house = mergeMlsOrg2HouseList.call(this, data.house, data.mlsOrgList);
                    // fix: Mobile map mode  save search The problem that the number of listings is not updated
                    if (
                        payload.isMobile &&
                        this.layout !== 'mixed'
                    ) {
                        this[RESULT_UPDATE_MUTATION](data);
                    }
                    this[TYPES.UPDATE_IS_MAP_LOADING](false);
                    this[TYPES.MAP_RESULT_UPDATE_MUTATION]({
                        ...data,
                        noMapSearch: this.noMapSearch
                    });
                    setTimeout(() => {
                        this[TYPES.SET_MAP_INITED](true);
                    }, 2500);
                    if (
                        this.layout !== 'mixed' &&
                        quickSearchCount &&
                        data.counts != quickSearchCount
                    ) {
                        updateQuickSearchCount.call(this, quickSearchKey, data.counts);
                    }
                })
                    .catch(error => {
                        this[TYPES.UPDATE_IS_MAP_LOADING](false);
                        throw error;
                    })
            );
        }
        

        this[TYPES.QUICK_SEARCH_STATE_MUTATION](0);
        await Promise.all(ps).catch(e => {
            if (e?.err?.errorInfo?.indexOf?.('Request canceled:') > -1) {
                console.log('Request canceled:', e);
            } else {
                throw e;
            }
        });
        if (payload.callback && util.isFunction(payload.callback)) {
            payload.callback();
        }
        if (!util.isSSRServer && window.siteAppVm) {
            window.siteAppVm.$EventBus.$emit('siteTrack', {
                trackType: 'search'
            });
        }

        function setDynamicRegisterParams(params) {
            //  Do not log map searches   only record listing-search
            if (params?.mapSearch) {
                return; 
            }
            //  Record parameters for each search ，dynamicRegister when needed
            if (!util.isSSRServer && localStorage) {
                localStorage.setItem(
                    'dynamicRegisterParams',
                    JSON.stringify(params) || '{}'
                );
            }
        }
    },
    [NAVIGATOR_DETAIL](payload) {
        if (this.goDetail) {
            this[SET_GO_DETAIL](false);
            if (
                Array.isArray(payload) &&
                payload.length === 1 &&
                window.location.pathname.indexOf('listing-for-cms') < 0
            ) {
                const data = payload[0];
                window.location.href = data.detailLink;
            }
        }
    },
    async [TYPES.UPDATE_URL]() {
        if (!util.isSSRServer) {
            let { page: globalData, isSearchCenter, forCMS } = getStore.call(this, 'page');
            if (forCMS) {
                return;
            }
            if (globalData.wordPressSSR) {
                return;
            }
            const params = Object.assign(
                {},
                this.otherUrlQuery,
                this.searchParamsWithMap,
                {
                    page: this.page
                }
            );
            if (isSearchCenter) {
                delete params.mapPath;
            }
            if (this.mapCondition.zoom) {
                params.zoom = this.mapCondition.zoom;
            }
            if (this.quickSearchState === 0) {
                if (params.quickSearchCount) {
                    delete params.quickSearchCount;
                }
                if (params.quickSearchKey) {
                    delete params.quickSearchKey;
                }
            }
            if (this.insightMode) {
                params.mode = this.insightMode;
            }
            let linkHash = await params2linkHash.call(this, params, globalData);
            let url = util.setQueryField(linkHash, window.location.pathname);
            window.history.replaceState({}, null, url);
        }
    },
    [SET_APPLY_MAP](payload) {
        this.applyMap = payload;
    }
};

export default {
    state: initState,
    getters,
    actions
};
